export default "__VITE_ASSET__BYHXY8y4__"